<template>
  <div class="flex flex-col place-content-center">
    <div class="flex flex-col gap-2">
      <h2 class="text-5xl font-medium leading-[3.5rem] tracking-[-0.04em] text-neutral-800">
        {{ t('auth.forgot_password.title') }}
      </h2>
      <p class="text-[1.125rem] font-normal leading-[1.4375rem] tracking-[-0.02em] text-neutral-500">
        {{ t('auth.forgot_password.under_title') }}
      </p>
    </div>

    <form class="mt-12 flex  flex-col place-content-center gap-2" @submit.prevent="onSubmit">
      <infuse-field :label="t('auth.common.email')">
        <infuse-input
          v-model="form.username"
          type="email"
          placeholder="name@company.com"
          :tabindex="1"
          required
          autofocus
        />
      </infuse-field>

      <div class="flex items-center justify-end gap-4">
        <router-link :to="{ name: 'auth-login' }">
          <label class="cursor-pointer text-xs font-bold leading-4 text-secondary-500">
            {{ t('auth.forgot_password.back_button') }}
          </label>
        </router-link>

        <infuse-button size="large" :loading="loading" type="submit" :tabindex="2">
          {{ t('auth.forgot_password.submit') }}
        </infuse-button>
      </div>
    </form>
  </div>
</template>

<script lang="ts" setup>
import { InfuseButton, InfuseField, InfuseInput } from '@infuse/ui/components';
import { reactive } from 'vue';
import { useI18n } from 'vue-i18n';

interface Props {
  loading?: boolean;
}

interface Emits {
  (e: 'submit', form: { username: string }): void;
}

defineProps<Props>();
const emit = defineEmits<Emits>();

const { t } = useI18n();

const form = reactive({
  username: ''
});

function onSubmit() {
  emit('submit', form);
}
</script>
